import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const POLL_MS = 5000;

export function usePendingDeliveries({ date, company = "all" }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/pending-deliveries", { params: { date, company } });
      setData(data);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }, [date, company]);

  useEffect(() => {
    setData(null);
    load();
    const t = setInterval(() => document.visibilityState === "visible" && load(), POLL_MS);
    return () => clearInterval(t);
  }, [load]);

  const mark = async (r, status, label) => {
    if (status !== "correct" && !window.confirm(`${label} · DAC ${r.dac_code} → ${status === "wrong" ? "DAC INCORRECT" : "BOOKING CANCELLED"}?`)) return false;
    setBusy(`${r.message_id}:${r.entry_index}`);
    try {
      await api.post(`/groups/${r.group_id}/messages/${r.message_id}/lpg/${r.entry_index}`, { status });
      await load();
      return true;
    } catch (e) {
      toast.error(formatApiError(e));
      return false;
    } finally {
      setBusy("");
    }
  };

  const undo = async (r) => {
    try {
      await api.post("/pending-deliveries/undo", { group_id: r.group_id, message_id: r.message_id, entry_index: r.entry_index });
      toast.success("Undo ho gaya — wapas Pending");
      await load();
      return true;
    } catch (e) {
      toast.error(formatApiError(e));
      return false;
    }
  };

  return { data, load, mark, undo, busy };
}
